import { useFormikContext } from "formik";
import InputBase from "components/Inputs/InputBase";
import { MutableRefObject, useRef, useState } from "react";
import classNames from "classnames";
import useFormikError from "hooks/useFormikError";
import { removeAccents } from "helpers";

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  url: string;
  autocomplete?: {
    field: string;
    type?: "slug";
  };
  type: "slug" | "text";
}
const InputURL: React.FC<Props> = ({
  name,
  label,
  placeholder,
  url,
  autocomplete,
  type,
}) => {
  const [active, setActive] = useState(false);
  const error = useFormikError(name);
  const { getFieldProps, setFieldValue, setFieldTouched } = useFormikContext();
  const ref: MutableRefObject<null | HTMLInputElement> = useRef(null);
  const value = getFieldProps(name)?.value;

  const handleSlugChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    const last = value.slice(-1);
    if (last === "-") {
      value = value.slice(0, -1);
    }

    const slug = removeAccents(value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .slice(0, 50);

    if (last === " ") {
      setFieldValue(name, slug + " ");
    } else setFieldValue(name, slug);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === "slug") {
      handleSlugChange(e);
    } else setFieldValue(name, e.target.value);
  };

  return (
    <InputBase label={label} name={name} autocomplete={autocomplete}>
      <div
        className={classNames(
          "min-h-[42px]  flex w-full overflow-hidden text-input font-normal bg-white border border-solid border-input-border rounded transition ease-in-out ",
          {
            "border-2 border-input-border-focus text-gray-700 shadow-input-focus":
              active,
            "hover:border-input-border-hover": !active,
            "border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red":
              error,
          }
        )}
        onFocus={() => setActive(true)}
        onBlur={() => {
          setActive(false);
          setFieldTouched(name);
        }}
      >
        <div
          className="bg-gray-100 px-2 py-1  min-w-[134px] flex items-center"
          onClick={() => ref.current?.focus()}
        >
          {url}
        </div>
        <input
          ref={ref}
          name={name}
          onChange={handleChange}
          value={value}
          className="focus:outline-none active:outline-none focus-visible:outline-none px-2 py-1 "
          placeholder={placeholder}
        />
      </div>
    </InputBase>
  );
};

export default InputURL;
